import React from 'react'
import styled from "styled-components"

const Wrapper = styled.div`
  padding: 0 48px;
  width: 100%;
`

export default props => <Wrapper {...props} />
